import React from 'react';
/** redux **/
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';

import Loader from '../../components/Loader';

// components
import Hero from '../../components/Hero.js';
import ContributorCard from '../../components/ContributorCard.js';
import BoostCard from '../../components/BoostCard.js';
import Card from '../../components/card/cardslide';
import SeeAllContributors from '../../components/SeeAllContributors';
import SecondaryStory from '../../components/SecondaryStory';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { format } from 'date-fns';
import QuillEditor from 'components/QuillEditor';
import { storeCityName } from 'utils/';

const styles = theme => ({
  featuredContainer: {
    padding: '20px',
    textAlign: 'left',
  },
  relatedContainer: {
    marginTop: '-10px',
  },
  centering: {
    [theme.breakpoints.only('lg')]: {
      maxWidth: '75%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
});

class Story extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  componentWillMount() {
    storeCityName(this.props.match.params.cityname);
  }
  componentDidMount() {
    let storyname = this.props.match.params.storyname;
    this.props.dispatch(actions.getData(storyname));
  }
  render() {
    const {
      classes,
      history,
      loading,
      story,
      // featured,
      related,
      storyById,
    } = this.props;
    if (loading) {
      return <Loader />;
    } else {
      const curyStory = story.data;
      const owner = curyStory.owner ? curyStory.owner : {};
      const ownerID = owner ? owner.id : '';

      const mainImage = storyById.data.entity.mainImage
        ? storyById.data.entity.mainImage
        : {};
      const cuisineExpert = storyById.data.entity.owner
        ? storyById.data.entity.owner.cuisinesOfExpertise
          ? storyById.data.entity.owner.cuisinesOfExpertise.map(cuisiness => {
              return cuisiness.name;
            })
          : []
        : [];
      return (
        <div>
          <Hero
            {...{
              title: storyById.data.entity.title,
              lastUpdated: format(curyStory.createdAt, 'MMM DD YYYY'),
              imageUrl: mainImage.uri,
              oneLiner: storyById.data.entity.summary,
            }}
          />
          <SecondaryStory
            {...{
              location: curyStory.location,
              cities: curyStory.city
                ? curyStory.city.map(city => {
                    return city.name;
                  })
                : '',
              cuisinesTags: curyStory.cuisines,
              dishesTags: curyStory.dishes
                ? curyStory.dishes.map(dish => {
                    return dish.name;
                  })
                : '',
              eateriesTags: curyStory.eateries
                ? curyStory.eateries.map(eatries => {
                    return eatries.name;
                  })
                : '',
              history,
            }}
          />
          <QuillEditor value={curyStory.content} readOnly={true} />
          {storyById.data.entity.owner ? (
            <ContributorCard
              {...{
                name: storyById.data.entity.owner.displayName,
                img: owner.profilePic
                  ? owner.profilePic.uri
                  : '/icons/user.png',
                oneLineDesc: storyById.data.entity.owner.userProfile.bio
                  ? storyById.data.entity.owner.userProfile.bio
                  : '',
                cuisines: cuisineExpert ? cuisineExpert : '',
                following: true,
                id: ownerID,
              }}
            />
          ) : (
            ''
          )}

          {storyById.data.contributions[0].owner ? (
            <SeeAllContributors contributors={storyById.data.contributions} />
          ) : (
            ''
          )}
          {storyById.data.comments[0].owner ? (
            <BoostCard comments={storyById.data.comments} />
          ) : (
            <BoostCard />
          )}
          {/* <BoostCard comments={story.comments} /> */}
          <div className={classes.featuredContainer}>
            {/* {featured.length > 0 ? (
              <Typography variant="body2">FEATURED</Typography>
            ) : (
              ''
            )}
            <br />
            <Card
              history={history}
              cards={featured}
              curatedBy={
                curyStory.owner.displayName ? curyStory.owner.displayName : ''
              }
            /> */}
            <br />
            <br />
            {related.length > 0 ? (
              <div className={classes.relatedContainer}>
                <Typography variant="body2">RELATED</Typography>
                <br />
              </div>
            ) : (
              ''
            )}
            <Card
              history={history}
              cards={related}
              curatedBy={
                curyStory.owner.displayName ? curyStory.owner.displayName : ''
              }
            />
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}

export default connect(mapStateToProps)(withStyles(styles)(Story));
